<div [formGroup]="formGroup">
  <ion-card mode="ios" class="team-card card-column-layout">
    <h4>{{ 'users.ruleByAttribute' | translate }}</h4>

      <ion-card-content class="ion-no-padding">
        <ion-grid class="scrollable-list">
          <ion-row>
            <ion-col size="4">Tipo de Atributo</ion-col>
            <ion-col size="6">Nome do Atributo</ion-col>
            <ion-col size="2">Ação</ion-col>
          </ion-row>

          <ion-row *ngFor="let attr of selectedAttributes; let i = index;">
            <ion-col size="4">
              {{ AttributeTypeEnum.Dictionary[attr.type].name }}
            </ion-col>
            <ion-col size="6">
              {{ attr.name }}
            </ion-col>
            <ion-col size="2">
              <ion-icon (click)="removeAttribute(i)" class="bp-delete question-group-delete" name="delete" color="danger"></ion-icon>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card-content>

    <div class="fixed-footer">
      <ion-grid>
        <ion-row>
          <ion-col size="5" class="ion-align-self-center">
            <ion-item>
              <ion-label position="stacked">
                {{ "feedback.config.attributeType" | translate }}
              </ion-label>
              <ion-select placeholder="Select" formControlName="attributeType" color="primary">
                <ion-select-option *ngFor="let attributeType of attributeTypes" [value]="attributeType.type">
                  {{ attributeType.name }}
                </ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>

          <ion-col size="5" class="ion-align-self-center">
            <ion-item>
              <ion-label position="stacked">
                {{ "feedback.config.attributeName" | translate }}
              </ion-label>
              <ion-select placeholder="Select" formControlName="attributeId" color="primary">
                <ion-select-option *ngFor="let attribute of attributes" [value]="attribute.id">
                  {{ attribute.name }}
                </ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>

          <ion-col size="2" class="btns">
            <ion-button (click)="addAttribute()">+</ion-button>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" class="ion-text-right">
            <ion-button (click)="save()" class="btn-save">{{ 'generic.save' | translate }}</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </ion-card>
</div>
